import { Routes, Route, BrowserRouter } from "react-router-dom";
import FastQuoteFlow from "./components/fastquote/FastQuoteFlow";
import "./App.css";

function App() {
  return (
    <div className="App CarbonPotentialApp">
      <BrowserRouter>
        <Routes>
          <Route path="/" element={<FastQuoteFlow></FastQuoteFlow>} />
          <Route
            path="estimate-your-carbon-potential/"
            element={<FastQuoteFlow></FastQuoteFlow>}
          />
          <Route
            path="calculate-your-carbon-potential/"
            element={<FastQuoteFlow></FastQuoteFlow>}
          />
          <Route path="drovers/" element={<FastQuoteFlow></FastQuoteFlow>} />
          <Route
            path="cattle-business/"
            element={<FastQuoteFlow></FastQuoteFlow>}
          />
          <Route path="western-ag/" element={<FastQuoteFlow></FastQuoteFlow>} />
          <Route path="cattlelink/" element={<FastQuoteFlow></FastQuoteFlow>} />
          <Route
            path="every-inch-of-topsoil-f/"
            element={<FastQuoteFlow></FastQuoteFlow>}
          />
          <Route
            path="every-inch-of-topsoil-r/"
            element={<FastQuoteFlow></FastQuoteFlow>}
          />
          <Route
            path="drovers-2024/"
            element={<FastQuoteFlow></FastQuoteFlow>}
          />
          <Route path="*" element={<FastQuoteFlow></FastQuoteFlow>} />
        </Routes>
      </BrowserRouter>
    </div>
  );
}

export default App;
